import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Route, Redirect, Switch } from "react-router-dom";
import { lighten } from '@material-ui/core/styles/colorManipulator';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

import LoginForm from 'app/components/auth/LoginForm';
import WelcomeRedirect from 'app/components/auth/Welcome';
import UserRegistrationForm from 'app/components/auth/registration/UserRegistrationForm';
import LoginSupport from 'app/components/auth/support/LoginSupport';
import PasswordEmailForm from 'app/components/auth/password/EmailForm';
import PasswordResetForm from 'app/components/auth/password/ResetForm';

import ClubAvatar from 'app/components/club/ClubAvatar';
import useApp from 'app/context/useApp';

import { img } from "app/styles/core";

const useStyles = makeStyles(theme => ({
    main: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '100%',
        width: '100%'
    },
    container: {
        zIndex: 12,
        height: '100%',
    },
    loginContainer: {
        padding: theme.spacing(4),

        [theme.breakpoints.down('sm')]: {
            padding: 0
        }
    },
    loginImage: {
        ...img,
        maxWidth: '320px',
        width: 'auto',
        maxHeight: '220px'
    },
    loginBranding: {
        marginBottom: theme.spacing(2),
        textAlign: 'center'
    },
    paper: {
        padding: theme.spacing(4),
        maxWidth: '680px'
    },
    emptyBorderPrimary: {
        border: '2px solid',
        borderColor: lighten(theme.palette.secondary.main, 0.62)
    }
}));

export default function AuthLayout(props) {

    const [ loading, setLoading ] = useState(false);
    const { app } = useApp();
    const classes = useStyles();

    const handleLoading = value => {
        setLoading(value)
    }

    return (
        <main className={classes.main}>
            <Grid container alignItems="center" justify="center" className={classes.container}>
                <Grid item className={classes.loginContainer}>
                    { loading ? (
                        <LinearProgress color="secondary"/>
                    ) : (
                        <div className={classes.emptyBorderPrimary}/>
                    )}
                    <Paper className={classes.paper}>
                        <div className={classes.loginBranding}>
                            {app.club ? (
                                <ClubAvatar club={app.club} />
                            ) : (
                                <img
                                    className={classes.loginImage}
                                    src={process.env.MIX_BRANDING}
                                    alt="Welcome to Club Apps"
                                />
                            )}
                        </div>
                        <Switch>
                            <Route path={'/login'} exact>
                                <LoginForm
                                    onLoading={handleLoading}
                                    loading={loading}
                                />
                            </Route>
                            <Route path={'/login/welcome'} exact>
                                <WelcomeRedirect
                                    onLoading={handleLoading}
                                    loading={loading}
                                />
                            </Route>
                            {(! app.club) &&
                                <Route path={'/register'} exact>
                                    <UserRegistrationForm onLoading={handleLoading} loading={loading}/>
                                </Route>
                            }
                            <Route path={'/support/login'} exact>
                                <LoginSupport />
                            </Route>
                            <Route path={'/password/email'} exact>
                                <PasswordEmailForm onLoading={handleLoading} loading={loading}/>
                            </Route>
                            <Route path={'/password/reset'} exact>
                                <PasswordResetForm onLoading={handleLoading} loading={loading}/>
                            </Route>
                            <Redirect to="/login" />
                        </Switch>
                    </Paper>
                </Grid>
            </Grid>
        </main>
    )
};
